module.exports = __webpack_public_path__ + "img/THQ_Screen_3.06db098f.jpg";